export enum SignupTypes {
  GENERIC_SIGNUP = 'signup',
  REPORT_SCANNER = 'report-scanner',
  SECURITY_QUESTIONNAIRE = 'security-questionnaire',
  AI_GRC_QA = 'ai-grc-qa',
}

export type SignUpProps = {
  header: string
  subHeader: string
  description: string
  signupType: SignupTypes
  redirectUrl: string
  isAuthed?: boolean
}

export const SIGN_UP_PROPS: Record<string, SignUpProps> = {
  genericSignup: {
    header: 'Welcome to Trustero',
    subHeader: 'Create your free account now!',
    description:
      'Create your free account to analyze SOC 2 reports and answer GRC questions using Trustero AI.',
    signupType: SignupTypes.GENERIC_SIGNUP,
    redirectUrl: '/dashboard',
  },
  reportSummary: {
    header: 'AI SOC 2 Report Summary',
    subHeader: 'Upload a SOC 2 Report for Quick, Automated Analysis',
    description:
      'AI SOC 2 Report Summary recognizes key features of the report using AI so you can get clarity about what the report really means.',
    signupType: SignupTypes.REPORT_SCANNER,
    redirectUrl: '/ai_soc2_report_summary',
  },
  aiGrcQa: {
    // below \u2011 is a non-breaking dash for styling
    header: 'AI GRC Q&A Free',
    subHeader:
      'Quick, concise, accurate answers to your GRC questions - Free for everyone!',
    description:
      'Trustero AI answers nuanced GRC questions faster and more accurately than a human based on your knowledge base.',
    signupType: SignupTypes.AI_GRC_QA,
    redirectUrl: '/ai_grc_qa',
  },
}

export const SIGNUP_REDIRECT_ROUTES: Record<SignupTypes, string> = {
  // These routes cannot be imported from the main app because of when this file is initialized
  [SignupTypes.GENERIC_SIGNUP]: '/dashboard',
  [SignupTypes.REPORT_SCANNER]: '/scan_report',
  [SignupTypes.SECURITY_QUESTIONNAIRE]: '/answer_questionnaire', // deprecated
  [SignupTypes.AI_GRC_QA]: '/answer_grc_questions',
}
